/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'copy': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M3.333 2.667a.667.667 0 0 0-.666.666v7.5a.667.667 0 0 0 .666.667h.834a1 1 0 1 1 0 2h-.834a2.667 2.667 0 0 1-2.666-2.667v-7.5A2.667 2.667 0 0 1 3.333.667h7.5A2.667 2.667 0 0 1 13.5 3.333v.834a1 1 0 1 1-2 0v-.834a.666.666 0 0 0-.667-.666h-7.5ZM9.167 8.5a.667.667 0 0 0-.667.667v7.5c0 .368.298.666.667.666h7.5a.667.667 0 0 0 .666-.666v-7.5a.667.667 0 0 0-.666-.667h-7.5ZM6.5 9.167A2.667 2.667 0 0 1 9.167 6.5h7.5a2.667 2.667 0 0 1 2.666 2.667v7.5a2.667 2.667 0 0 1-2.666 2.666h-7.5A2.667 2.667 0 0 1 6.5 16.667v-7.5Z" _fill="#4990E2"/>'
  }
})
